module.exports = __webpack_public_path__ + "experience/innovation/images/hero.85d1d3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-experience/Experience/images/hero.jpg
// module id = /bR7
// module chunks = 1